import { render, staticRenderFns } from "./UpdateReport.vue?vue&type=template&id=c6e6b05e"
import script from "./UpdateReport.vue?vue&type=script&lang=js"
export * from "./UpdateReport.vue?vue&type=script&lang=js"
import style0 from "./UpdateReport.vue?vue&type=style&index=0&id=c6e6b05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports